import React from 'react';
import { Card, Row, Col, Skeleton } from 'antd';

// Skeleton générique pour les pages de détail (header KPI + card principale).
// Beaucoup plus rapide perçu qu'un Spin plein écran : l'utilisateur voit la structure immédiatement.
const DetailSkeleton = ({ kpis = 4, sections = 2 }) => {
    return (
        <div className="content-wrapper">
            <div className="container-xxl flex-grow-1" style={{ padding: 16 }}>
                <Skeleton.Input active size="small" style={{ width: 200, marginBottom: 12 }} />

                <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
                    {Array.from({ length: kpis }).map((_, i) => (
                        <Col xs={12} sm={6} key={i}>
                            <Card size="small" style={{ borderRadius: 10, textAlign: 'center' }} bodyStyle={{ padding: 16 }}>
                                <Skeleton.Input active size="small" style={{ width: 80, marginBottom: 8 }} />
                                <Skeleton.Input active size="default" style={{ width: 120 }} />
                            </Card>
                        </Col>
                    ))}
                </Row>

                {Array.from({ length: sections }).map((_, i) => (
                    <Card key={i} style={{ borderRadius: 12, marginBottom: 16 }}>
                        <Skeleton active paragraph={{ rows: 4 }} />
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default DetailSkeleton;
